module.exports = __webpack_public_path__ + "img/keegan_sq.9c70b107.jpg";